<script setup>
import { ref } from 'vue'
import { CreditCardIcon, BanknotesIcon } from '@heroicons/vue/20/solid'
import { XMarkIcon } from '@heroicons/vue/24/outline'
import { useRestoGLobalStore } from '@/stores/restoGlobalStore'
import { useCartGLobalStore } from '@/stores/cartGlobalStore'
import { updatPaymentTypeFn } from '@/services/api/restApiCalls'

const restoStore = useRestoGLobalStore()
const cartStore = useCartGLobalStore()
const selectedPaymentType = ref(cartStore.CART_DATA?.order_payment_type)
const handleChangePayType = async () => {
  let payTypeFormData = new FormData()
  payTypeFormData.append('resto_id', restoStore?.RESTO_ID)
  payTypeFormData.append('payment_type', selectedPaymentType.value)
  const payment_type = await updatPaymentTypeFn(payTypeFormData)
  cartStore.CART_DATA = payment_type[restoStore?.RESTO_ID]
}
</script>
<template>
  <div
    class="bg-gradient-to-r from-gray-100 to-gray-200 dark:from-gray-700 dark:to-gray-800 flex items-center md:px-2 px-1 md:py-2 py-1 md:mb-3 mb-1 rounded-lg w-full shadow-md transition-all duration-300"
  >
    <button
      class="w-1/2 relative cursor-pointer text-base flex justify-center items-center sm:px-6 px-4 py-1 text-gray-800 dark:text-gray-100 rounded-lg border-none focus:outline-none focus:ring focus:ring-opacity-50 transition-all duration-300 ease-in-out transform hover:scale-[1.02] disabled:bg-gray-100 disabled:dark:bg-gray-600 disabled:cursor-not-allowed disabled:text-slate-400 disabled:transform-none mr-1"
      :class="[
        cartStore.CART_DATA?.order_payment_type == 'cash'
          ? 'bg-gradient-to-r from-yellow-500 to-yellow-600 text-white shadow-md focus:ring-yellow-400'
          : 'bg-white dark:bg-gray-800 hover:shadow-md focus:ring-gray-400',
        !restoStore?.restoInfo?.is_cash_payment_available ? 'line-through opacity-75' : ''
      ]"
      :disabled="!restoStore?.restoInfo?.is_cash_payment_available"
      @click="handleChangePayType((selectedPaymentType = 'cash'))"
    >
      <BanknotesIcon class="sm:h-5 h-4 sm:w-5 w-4 mr-2" aria-hidden="true" />
      <span class="sm:text-base text-sm font-medium">Cash</span>
      <XMarkIcon
        v-if="!restoStore?.restoInfo?.is_cash_payment_available"
        class="h-7 w-7 text-red-400 absolute"
        aria-hidden="true"
      />
    </button>
    <button
      class="w-1/2 relative cursor-pointer text-base flex justify-center items-center sm:px-3 px-2 py-1 text-gray-800 dark:text-gray-100 rounded-lg border-none focus:outline-none focus:ring focus:ring-opacity-50 transition-all duration-300 ease-in-out transform hover:scale-[1.02] disabled:bg-gray-100 disabled:dark:bg-gray-600 disabled:cursor-not-allowed disabled:text-slate-400 disabled:transform-none ml-1"
      :class="[
        cartStore.CART_DATA?.order_payment_type == 'card'
          ? 'bg-gradient-to-r from-purple-500 to-purple-600 text-white shadow-md focus:ring-purple-400'
          : 'bg-white dark:bg-gray-800 hover:shadow-md focus:ring-gray-400',
        !restoStore?.restoInfo?.is_card_payment_available ? 'line-through opacity-75' : ''
      ]"
      :disabled="!restoStore?.restoInfo?.is_card_payment_available"
      @click="handleChangePayType((selectedPaymentType = 'card'))"
    >
      <CreditCardIcon class="sm:h-5 h-4 sm:w-5 w-4 mr-2" aria-hidden="true" />
      <span class="sm:text-base text-sm font-medium">Card</span>
      <XMarkIcon
        v-if="!restoStore?.restoInfo?.is_card_payment_available"
        class="h-7 w-7 text-red-400 absolute"
        aria-hidden="true"
      />
    </button>
  </div>
</template>

<style scoped>
button {
  position: relative;
  overflow: hidden;
}

button::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.1);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

button:hover::after {
  opacity: 1;
}

@media (hover: none) {
  button:hover::after {
    opacity: 0;
  }
}
</style>
